angular.module('app.filters', [])  

  .filter 'range', () ->
    return (input, total) ->
      total = parseInt(total)
      for i in [0..total]
        input.push(i)
      return input

  .filter 'nl2br', () ->
    return (string) ->
      if (typeof string != 'string') 
        return ''
      
      return string.replace(/\n/g, '<br />')

  .filter 'join', () ->
    return (array) ->    
      return array.filter((item) -> return !!item).join(' ')

  .filter 'slug', () ->
    return (string) ->    
      return string.trim().toLowerCase().replace(/[\W_]+/g, '-').replace(/^-+|-+$/g, '')

  .filter 'location', () ->
    return (object) ->    
      array = []
      array.push object.street + "," if object.street
      array.push object.postcode if object.postcode
      array.push object.location if object.location

      return encodeURI(array.join(' '))

  .filter 'time', ['$filter', ($filter) ->
    return (input, arg) ->
      return unless input?
      parts = input.split(':')
      date = new Date(0, 0, 0, parts[0], parts[1], parts[2]);
      return $filter('date')(date, arg || 'HH:mm')
  ]

  .filter 'matches', () ->
    return (string, length, offset) ->    
      before = string.substring(0, offset)
      after = string.substring(offset + length)
      match = string.substring(offset, length)
      
      return "#{before}<b>#{match}</b>#{after}"